import * as types from './types';

const publishPosting = publishData => ({
  type: types.PUBLISH_POSTING,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: '/panel/api/v2/posting/publish',
    method: 'PUT',
    body: publishData
  }
});

const resetPublishPosting = () => ({
  type: types.RESET_PUBLISH_POSTING
});

export { publishPosting, resetPublishPosting };
